module.exports = __webpack_public_path__ + "assets/ic_condition_white_02.39ea790e.svg";